/**
 * Build-time site mode, set via the REACT_APP_SITE_MODE env variable
 * (see .github/workflows/*.yml for CI, or run locally e.g.
 *   REACT_APP_SITE_MODE=management npm start
 *
 * Modes:
 *  - "published"  → Published Projects site only
 *  - "management" → Project Management site only
 *  - "both"       → both products with the flow switcher (default)
 *
 * CRA inlines the env var at build time, so single-mode builds have the
 * other product's routes and nav entries compiled out.
 */

export const SITE_MODE_PUBLISHED = "published";
export const SITE_MODE_MANAGEMENT = "management";
export const SITE_MODE_BOTH = "both";

const raw = (process.env.REACT_APP_SITE_MODE || SITE_MODE_BOTH).toLowerCase();

export const SITE_MODE =
    raw === SITE_MODE_PUBLISHED || raw === SITE_MODE_MANAGEMENT ? raw : SITE_MODE_BOTH;

export const PUBLISHED_ENABLED = SITE_MODE !== SITE_MODE_MANAGEMENT;
export const MANAGEMENT_ENABLED = SITE_MODE !== SITE_MODE_PUBLISHED;

/** True when both products are built in (product switcher shown). */
export const IS_DUAL_MODE = PUBLISHED_ENABLED && MANAGEMENT_ENABLED;
